export default __webpack_public_path__ + "static/media/Leggings of Unrest.fc491874.jpg";